/**@Icons */
import { LuDot } from "react-icons/lu";
import houses from "../../../../assets/pics/houses.svg";
export default function VenueActivity({ venueRepresent, venueSetting }) {
	return (
		<div className="flex items-center gap-2 min-h-[20px] flex-nowrap w-full">
			<img src={houses} alt="" />
			<div className="text-secondary font-outfit font-normal text-[15px] leading-[156%] tracking-[0.01em] flex items-center min-w-0 truncate">
				{venueRepresent}{" "}
				{venueRepresent && venueSetting && (
					<span>
						<LuDot className="text-[#5e5e5e] text-xl rounded-full" />
					</span>
				)}
				{/* {venueSetting?.length === 1 ? venueSetting?.[0] : "Indoor + Outdoor"} */}
				{venueSetting ? venueSetting : "Indoor + Outdoor"}
			</div>
		</div>
	);
}
